module.exports = __webpack_public_path__ + "static/media/combined-shape-1.332bf57a.svg";